import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  style: {
    "font-size": "0.8rem"
  }
};
const _hoisted_2 = {
  class: "prop-card"
};
const _hoisted_3 = {
  class: "transaction-desc"
};
const _hoisted_4 = {
  class: "order_price"
};
import { computed, ref } from 'vue';
import { Box } from '@element-plus/icons-vue';
import { ElIcon, ElMessage, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { Decimal } from "decimal.js";
export default {
  __name: 'PendingOrder',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  emits: ['update'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null); // computed

    const roleArray = computed(() => store.state.role_array ?? []);
    const isSeller = computed(() => {
      const buffer = roleArray.value.map(role => role.id);
      return buffer.includes(props.order.seller?.id);
    });
    const sellerInfo = computed(() => {
      return `${props.order.seller?.nickname}（id:${props.order.seller?.id}）`;
    });
    const buyerInfo = computed(() => {
      return `${props.order.buyer?.nickname}（id:${props.order.buyer?.id}）`;
    });
    const orderPrice = computed(() => {
      const price = props.order.price;
      const adjustPrice = props.order.adjust_price;

      if (adjustPrice === 0.0) {
        return price.toFixed(1);
      }

      const finalPrice = Decimal(price).plus(Decimal(adjustPrice)).toFixed(1);

      if (adjustPrice > 0) {
        return `${finalPrice}（${price.toFixed(1)} + ${adjustPrice.toFixed(1)}）`;
      } else {
        return `${finalPrice}（${price.toFixed(1)} - ${Math.abs(adjustPrice).toFixed(1)}）`;
      }
    }); // functions

    function cancelTraderOrder(item) {
      if (message.value) {
        message.value.close();
      }

      if (!item['id']) {
        message.value = ElMessage.error({
          message: '错误的订单号',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'order_id': item['id']
      };
      request('transaction/role_transaction/cancel/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        message.value = ElMessage.success({
          message: '交易已撤销',
          duration: 1500
        });
        emits('update');
      });
    }

    function agreeTraderOrder(item) {
      if (message.value) {
        message.value.close();
      }

      if (!Object.keys(item).includes('id')) {
        message.value = ElMessage.error({
          message: '错误的订单号',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'order_id': item['id']
      };
      request('transaction/role_transaction/accept/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        if (isSeller.value) {
          store.commit('delete_role_info', {
            role_id: props.order.seller.id,
            key: 'attribute'
          });
        } else {
          store.commit('delete_role_info', {
            role_id: props.order.buyer.id,
            key: 'attribute'
          });
        }

        store.dispatch('get_roles');
        emits('update');
        message.value = ElMessage.success({
          message: '贸易订单已完成',
          duration: 1500
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createBlock(_unref(ElRow), {
        class: "pending-orders-card"
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_1, [_createElementVNode("b", null, _toDisplayString(isSeller.value ? '正在销售道具' : '道具交易请求'), 1)]), _createVNode(_unref(ElRow), {
          style: {
            "width": "100%",
            "margin": "5px 0",
            "justify-content": "center"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElIcon), {
            size: 14,
            style: {
              "margin-right": "8px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(Box))]),
            _: 1
          }), _createElementVNode("text", null, _toDisplayString(__props.order['prop']['name']), 1)])]),
          _: 1
        }), _createElementVNode("text", _hoisted_3, "         " + _toDisplayString(isSeller.value ? `您的角色${sellerInfo.value}正贩卖道具给${buyerInfo.value}` : `${sellerInfo.value}正向您的角色${buyerInfo.value}兜售商品`), 1), _createElementVNode("div", null, [_createElementVNode("text", null, "         " + _toDisplayString(isSeller.value ? `道具出价是` : `需要支付`), 1), _createElementVNode("text", _hoisted_4, [_cache[2] || (_cache[2] = _createTextVNode("   ", -1)), _createElementVNode("b", null, _toDisplayString(orderPrice.value), 1)])]), _createVNode(_unref(ElRow), {
          class: "operate-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: _normalizeClass([isSeller.value ? 'cancel' : 'reject', "cancelTraderOrder"]),
            onClick: _cache[0] || (_cache[0] = $event => cancelTraderOrder(__props.order))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(isSeller.value ? '撤销交易' : '拒绝交易'), 1)]),
            _: 1
          }, 8, ["class"]), isSeller.value && !__props.order.seller_agree || !isSeller.value && !__props.order.buyer_agree ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[1] || (_cache[1] = $event => agreeTraderOrder(__props.order)),
            class: "agreeTraderOrder"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 接受交易 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      });
    };
  }

};